export default __webpack_public_path__ + "static/jazz-by-river-01-eff4bba17be621654cdef9a37305b435.webp";